import React, {useContext, useState} from "react";
import AppContext from "/context/AppContext";
import FoyerInfoBackground from "/components/shared/layouts/FoyerInfoBackground";
import EnjoyTheShow from "/components/shared/EnjoyTheShow";
import RoomLayout from "/components/shared/layouts/RoomLayout";
import RoomButton from "/components/shared/buttons/RoomButton";
import PosterWallMobile from "/components/shared/PosterWallMobile";
import UpcomingShowsMobile from "/components/shared/UpcomingShowsMobile";
import Slider from "react-slick";
import {
    SvgTailRight2,
    SvgTap,
    SvgTheaterCurtains1,
    SwiperArrowLeft,
    SwiperArrowRight,
} from "/components/shared/SvgIcons";

export function Welcome() {
    return (
        <FoyerInfoBackground style="mt-14 py-2 sm:py-4 px-8 sm:px-12">
            <h3 className="text-white text-lg text-center">
                Willkommen im
                <br/>
                Jungen Theater <br/> Bonn online!
            </h3>
          <div className="text-center text-white">
            <b className="text-red-400">BETA VERSION</b>
            <p >Bitte wenden Sie sich bei Fragen oder Problemen an <a href="mailto:info@jt-bonn.de">info@jt-bonn.de</a></p>
          </div>
            <div className="flex justify-center">
                <div className="flex justify-center items-center pr-4">{SvgTailRight2()}</div>
                {SvgTap()}
                <div className="flex justify-center items-center pl-4 rotate-y-180">
                    {SvgTailRight2()}
                </div>
            </div>
            <div className="text-sm md:text-base text-white text-center">
                Nach links und rechts wischen <br/> zum Navigieren
            </div>
        </FoyerInfoBackground>
    );
}

export default function FoyerMobile() {
    const {activeShow, setActiveShow} = useContext(AppContext);
    const [sliderRef, setSliderRef] = useState(null);

    const settings = {
        arrows: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
        speed: 500,
    };

    return (
        <RoomLayout
            swiper={true}
            key="room"
            background="bg-cover bg-roomImage"
            hideOverflow
        >
            <Slider ref={setSliderRef} {...settings}>
                <div>
                    <UpcomingShowsMobile/>
                    <div className="flex justify-end mt-0 sm:mt-4">
                        <div
                            onClick={sliderRef?.slickNext}
                            className="m-2 sm:m-4 bg-white rounded-full h-8 w-8 flex justify-center items-center"
                        >
                            {SwiperArrowRight()}
                        </div>
                    </div>
                </div>
                <div>
                    <div>
                        <div
                            className="flex-1 flex flex-col justify-center items-center space-between mt-[10vh] sm:h-[600px]">
                            <div className="flex justify-center">
                                {activeShow ? <EnjoyTheShow show={activeShow}/> : <Welcome/>}
                            </div>

                            <div className={`mt-6 sm:mt-8 flex justify-center w-max`}>
                                <RoomButton
                                    href="/about-theater/description"
                                    className="px-4 py-2"
                                >
                                    <div className="mr-2">{SvgTheaterCurtains1("#AC8243")}</div>
                                    Das Theater kennenlernen
                                </RoomButton>
                            </div>
                            <div className="fixed bottom-10 md:w-screen md:flex md:justify-end md:mr-32">
                                <img
                                    className="w-56 sm:w-64 2xl:hidden sm:mt-8 z-10"
                                    src="/assets/images/neustart-kultur-logo.jpg"
                                />
                            </div>
                        </div>
                        <div className="flex justify-between fixed bottom-0 w-screen">
                            <div
                                onClick={sliderRef?.slickPrev}
                                className="m-2 sm:m-4 bg-white rounded-full h-8 w-8 flex justify-center items-center"
                            >
                                {SwiperArrowLeft()}
                            </div>
                            <div
                                onClick={sliderRef?.slickNext}
                                className="m-2 sm:m-4 bg-white rounded-full h-8 w-8 flex justify-center items-center"
                            >
                                {SwiperArrowRight()}
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <PosterWallMobile/>
                    <div className="fixed bottom-0 w-screen">
                        <div
                            onClick={sliderRef?.slickPrev}
                            className="m-2 sm:m-4 bg-white rounded-full h-8 w-8 flex justify-center items-center"
                        >
                            {SwiperArrowLeft()}
                        </div>
                    </div>
                </div>
            </Slider>
        </RoomLayout>
    );
}
